import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Orientation extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Orientation</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Very Unsuccessful and
                                5-Very Successful...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formOrientation"
                                controlId="formOrientation"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    25. How successful was your orientation?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formOrientation"
                                    id="formOrientation-1"
                                    defaultChecked={this.props.formOrientation === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formOrientation"
                                    id="formOrientation-2"
                                    defaultChecked={this.props.formOrientation === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formOrientation"
                                    id="formOrientation-3"
                                    defaultChecked={this.props.formOrientation === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formOrientation"
                                    id="formOrientation-4"
                                    defaultChecked={this.props.formOrientation === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formOrientation"
                                    id="formOrientation-5"
                                    defaultChecked={this.props.formOrientation === 5}
                                />
                                </Form.Group>
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Orientation;